import { styled, TableCell } from "@mui/material";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: theme.spacing(0.8, 1.2),
    fontSize: '0.8rem',
    lineHeight: 1.3,
    transition: 'all 0.2s ease',

    '&.MuiTableCell-head': {
        backgroundColor: theme.palette.primary.main,
        fontWeight: 600,
        color: theme.palette.primary.contrastText,
        padding: theme.spacing(0.8, 1.4),
        fontSize: '0.75rem',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },

    '&.MuiTableCell-body': {
        color: theme.palette.text.primary,
    },

    '&.MuiTableCell-root': {
        borderBottom: `1px solid ${theme.palette.divider}`,
    },

    '&:first-of-type': {
        paddingLeft: theme.spacing(1.5),
    },
    '&:last-of-type': {
        paddingRight: theme.spacing(1.5),
    },

    // Zebra striping for even rows
    'tr:nth-of-type(even) &': {
        backgroundColor: theme.palette.grey[200], // Light gray for even rows
    },
}));